import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unit : null,
  slide : [],
  word_play : false,
};

const card = createSlice({
  name : "card",
  initialState,
  reducers : {
    resetCard : () => initialState,
    setCardUnit(state, action) {
      state.unit = action.payload;
    },
    setSlide(state, action) {
      state.slide = action.payload;
    },
    setWordPlay(state, action) {
      state.word_play = action.payload;
    }
  }
});

export const { resetCard, setCardUnit, setSlide, setWordPlay } = card.actions;
 
export default card;